import http from "../../../services/http";

import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";

// 契約解除（契約者でなくなった）解除対象施設一覧表示API
import {
  IAPI_CON010_Request as InfoRequest,
  IAPI_CON010_Response as InfoResponse,
} from "../../../type/apiType";

// 契約解除（契約者でなくなった）解除対象施設一覧表示API
// API仕様書_契約者
const httpIAPI_CON010 = async (param: InfoRequest): Promise<InfoResponse> => {
  let res = await http.post(ApiUrl.API_CON010, {
    ...param,
  });
  return res.data;
};

export { httpIAPI_CON010 };
